import type { MessageKey } from '../i18n/en';

/**
 * What a new password needs. The account server enforces the same rules
 * (apps/api/src/rules.ts); this list drives the live checklist.
 */
export const PASSWORD_RULES: { label: MessageKey; test: (password: string) => boolean }[] = [
  { label: 'password.length', test: (password) => password.length >= 8 },
  { label: 'password.upper', test: (password) => /\p{Lu}/u.test(password) },
  { label: 'password.lower', test: (password) => /\p{Ll}/u.test(password) },
  { label: 'password.number', test: (password) => /\d/.test(password) },
];

export function isStrongPassword(password: string): boolean {
  return PASSWORD_RULES.every((rule) => rule.test(password));
}
